import { useMutation } from '@apollo/client';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import { gql } from '__generated__';
import { FC, useState } from 'react';

import Button from 'components/Button';
import { FormInput, FormPanel } from 'components/FormPanel';

const BULK_UPLOAD_USER_MUTATION = gql(`
  mutation BulkUploadUser($file: Upload!) {
    bulkUploadUser(file: $file) {
      status
    }
  }
`);

const BulkUploadUserDialogButton: FC<{ departmentId: string }> = ({ departmentId }) => {
  const [showDialog, toggleDialog] = useState(false);

  const [bulkUploadUser, { loading, error }] = useMutation(BULK_UPLOAD_USER_MUTATION, {});

  return (
    <>
      <Button onClick={() => toggleDialog(true)}>Upload Document</Button>
      <Dialog open={showDialog} onClose={() => toggleDialog(false)} maxWidth="xs" fullWidth>
        <DialogTitle>Bulk Upload User</DialogTitle>
        <DialogContent sx={{ minHeight: '50vh' }}>
          <FormPanel
            loading={loading}
            error={error}
            onCancel={() => toggleDialog(false)}
            onSubmit={data => {
              bulkUploadUser({
                variables: {
                  file: data.file,
                },
              }).then(() => toggleDialog(false));
            }}
          >
            <FormInput fullWidth type="upload" fieldName="file" label="Document" defaultValue="" />
          </FormPanel>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default BulkUploadUserDialogButton;
